import { render, staticRenderFns } from "./cModalAlmaPharmacy.vue?vue&type=template&id=20e4f7a6"
import script from "./cModalAlmaPharmacy.vue?vue&type=script&lang=js"
export * from "./cModalAlmaPharmacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports